import styled from "styled-components";
import { SuccessButton } from "../styles/button";
import { FormStyle, InputStyle } from "../styles/form";
import { MouseEvent, useCallback, useState } from "react";
import {
  createSession,
  deleteSession,
  useSession,
} from "../stores/session_store";
import { translate, Translate } from "../components/translate";
import { useLanguage } from "../stores/language_store";

export function Home() {
  const session = useSession();
  const [email, setEmail] = useState<string>();
  const language = useLanguage();

  const handleLogin = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      if (email !== undefined) {
        createSession({ email, createdAt: new Date().toISOString() });
      }
    },
    [email]
  );

  const handleLogout = useCallback((e: MouseEvent) => {
    e.preventDefault();
    deleteSession();
  }, []);

  return (
    <Container>
      <Title>
        <Translate value="welcome_title" />
      </Title>
      {session === undefined ? (
        <FormStyle>
          <h2>
            <Translate value="connection" />
          </h2>
          <InputStyle
            type="email"
            placeholder={translate("email", language)}
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <SuccessButton onClick={handleLogin}>
            <Translate value="login" />
          </SuccessButton>
        </FormStyle>
      ) : (
        <>
          <div>
            <Translate value="welcome" /> {session.email}
          </div>
          <div>
            <Translate value="timeConnection" />{" "}
            {new Date(session.createdAt).toLocaleString()}
          </div>
          <SuccessButton onClick={handleLogout}>
            <Translate value="logout" />
          </SuccessButton>
        </>
      )}
    </Container>
  );
}

const Container = styled.div`
  margin: 20px;
  text-align: center;
`;

const Title = styled.h1`
  margin-bottom: 80px;
  margin-top: 50px;
`;
